<template>
    <!-- 超值赠礼 - 查看详情 -->
    <div class="goodgiftdetail">
        <div class="title flex_layout flex_y_center flex_x_spacebetween">
            <p>购买成功后<span>任选3个</span>领取</p>
            <i @click="clickCloseDetailBtn()"></i>
        </div>
        <div id="goodgiftdetaillist" class="list"
            v-on:[eventname].stop="()=>{}"
        >
            <ul>
                <li class="listitem flex_layout" v-for="(item, index) in list" :key="index">
                    <div class="limg flexitem_flexshrink_0">
                        <img src="https://f2.kkmh.com/image/181025/4diVYyMUJ.webp-t.w320.webp.h">
                    </div>
                    <div class="rinfo">
                        <div class="rinfo-top flex_layout flex_x_spacebetween">
                            <p class="rinfo-top-title">网易云音乐年度会员</p>
                            <p class="rinfo-top-price">价值：<span>￥188</span></p>
                        </div>
                        <div class="rinfo-desc">
                            <p>快看漫画会员年卡购买成功后，免费送12个月网易云音乐会员</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'GoodGiftDetail',
            data () {
            return {
                elnode : '',
                flag : false,
            }
        },
        props: {
            h_data_goodinfo:{
                type: Object,
                default () {
                    return {}
                }
            },
        },
        watch:{
            h_data_goodinfo:{
                handler(val){
                    // 1.更新数据computed-list
                    this.flag = !this.flag;
                    // 2.computed-list渲染后，再执行couputed-eventname
                    this.$nextTick(() => {
                        this.elnode = '';
                        this.elnode = document.getElementById('goodgiftdetaillist');    
                    })
                },
                deep:true
            },
        },
        computed: {
            list(){
                if (this.flag) {
                    return [{},{},{},{},{},{},{}];    
                } else {
                    return [{},{}];
                }
            },
            eventname(){
                // console.log('computed',this.elnode.scrollHeight,this.elnode.clientHeight);
                if (this.elnode && (this.elnode.scrollHeight > this.elnode.clientHeight)) {
                    return 'touchmove';
                } else {
                    return '';
                }
            }
        },
        mounted(){
            // console.log('mounted');
            this.elnode = document.getElementById('goodgiftdetaillist');
        },
        methods:{
            clickCloseDetailBtn(){
                this.$emit('clickCloseDetailBtn');
            },
            getWord(obj, key){
                let v = obj.words_info ? obj.words_info : {};
                return v[key] ? v[key] : '';
            },
        },
    }
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.goodgiftdetail{
    width:100%;
    min-height:vws(750px);
    max-height:vws(1110px);
    background:#F7F7F8;
    border-radius: vws(20px) vws(20px) 0px 0px;
    .title{
        height:vws(94px);
        padding:0 vws(20px) 0 vws(24px);
        p{
            font-size:vws(30px);
            font-weight:bold;
            line-height:0px;
            color:#333333;
            span{
                color:#FF751A;
                padding:0 vws(4px);
            }
        }
        i{
            display:inline-block;width:vws(56px);height:vws(56px);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAABwCAMAAADxPgR5AAAAP1BMVEUAAABKNjhKODxLPDxLNzlKNjhgYGBMODtKNjlLNjhKNjlLNzlLNzlNNzpMNjxKODpLNzlKNjlKNjlPNz1KNjiq7616AAAAFHRSTlMA8DcQznEFHevny6aDUy899tjAKsz4PYAAAAD8SURBVGje7dfNioNAFEThq850+xedJP3+zzoTJiDkxN2tTaizbfADaSwM55xzzjnnnHPOuY+qLtO01PdnZb12tz3ZG9tfXR/Bhrk9uqSCS2tn4vD1fzaWTHBqhwjv2ZYLHiI8Bbi0Q4SneKW1o3h4gksT/YsI7ztCK9JTi/TEIj2tKPYoij2Keo+i3qNITy3S04l6j9+XH+6jyjvbR61HUexR1HsUZfdFK3L/uI9aj/uo9iCKPYhiTy6W+cWjeE8FV3gQ51TwCo9izQQ7eBT7TPAGj+KQCe7wIK6R2mVsbTz5X7nPD69EbmXbzh9Z9yGcc84555xzzjnnlP0Cz7swBtFHw08AAAAASUVORK5CYII=") no-repeat 0 0;background-size: 100% 100%;
        }
    }
    .list{
        max-height:vws(1016px);
        overflow-y:scroll;
        -webkit-overflow-scrolling: touch;
        padding:0 vws(24px);
        .listitem{
            padding:vws(24px) vws(24px) vws(28px) vws(24px);
            margin-bottom:vws(20px);
            background:#fff;
            border-radius:vws(16px);
            .limg{
                width:vws(88px);
                height:vws(88px);
                img{height:100%;width:100%;};
            }
            .rinfo{
                padding:vws(4px) 0 0 vws(20px);
                .rinfo-top{
                    .rinfo-top-title{
                        font-size:vws(28px);
                        font-weight:bold;
                        color:#333;
                    }
                    .rinfo-top-price{
                        font-size:vws(28px);
                        font-weight:bold;
                        color:#666;
                        span{color:#FF751A;};
                    }
                }
                .rinfo-desc{
                    padding-top:vws(12px);
                    font-size:vws(24px);
                    color:#999;
                    p{
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 10;
                        overflow: hidden;
                    }
                }
            }
        }
    }
    
}
</style>




// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/GoodGiftDetail.vue